var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "solicitudes" },
    [
      _c("WidgetUser"),
      _c("mis-solicitudes-filters", {
        attrs: {
          categoriaUsuario: _vm.categoriaUsuario,
          empresas: _vm.empresas
        },
        on: {
          filter: function($event) {
            return _vm.getFilter($event)
          },
          lstCuenta: function($event) {
            return _vm.grupoCuenta($event)
          },
          exportar: function($event) {
            return _vm.exportarExcel($event)
          }
        }
      }),
      _c("mis-solicitudes-table", {
        attrs: { tableData: _vm.tableData, totalItems: _vm.totalRegistros }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }